import BaseAPI from '../api'
const path = 'roles'
export interface RoleInterface {
    idRole?: number
    roleName?: string
    roleStatus?: string
    permission?: any
    page?: number;
    limit?: number;
    keyword?: string;
    sortBy?: string;
    sortType?: string;
}

export default class RoleApi extends BaseAPI {

    static getRoles(props: RoleInterface): Promise<any> {
        return this.api.get(`${path}`, { params: { ...props } })
            .then((res) => res)
    }
    static postRole(props: RoleInterface): Promise<any> {
        return this.api.post(`${path}`, { ...props }, {})
            .then((res) => res)
    }
    static patchRole(idRole: string, props: RoleInterface): Promise<any> {
        return this.api.patch(`${path}/${idRole}`, { ...props }, {})
            .then((res) => res)
    }
    static getRole(props: RoleInterface): Promise<any> {
        return this.api.get(`${path}/${props.idRole}`, {})
            .then((res) => res)
    }
}